import type { Options, OptionsStrict } from './types';

type DefaultOptions = Pick<
  OptionsStrict,
  'responseType' | 'selector' | 'defaultValue'
>;

export const defaultOptions: DefaultOptions = {
  responseType: 'json',
  selector: (json: any, options: Options) => json?.data ?? options.defaultValue,
  defaultValue: undefined,
};
